import { render, staticRenderFns } from "./DeliveryBillList.vue?vue&type=template&id=66f919af&scoped=true&"
import script from "./DeliveryBillList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBillList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryBillList.vue?vue&type=style&index=0&id=66f919af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f919af",
  null
  
)

export default component.exports